import useGetCustomersTableConfig from './useGetCustomersTableConfig'

export default useGetCustomersTableConfig
